import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/back_arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-7b88df2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment_panel" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import Row from '../common/RowSection.vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSection',
  props: {
        text: String,
        disabled: Boolean,
    },
  emits: ['next-step'],
  setup(__props, { emit: nextStep }) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Row, { text: __props.text }, null, 8, ["text"]),
    _createVNode(Row, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("button", {
          class: "bbtn",
          disabled: __props.disabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (nextStep('next-step'))),
          style: {"display":"none"}
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('back')), 1)
        ], 8, _hoisted_2)
      ]),
      _: 3
    })
  ]))
}
}

})